var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0573921 7.93565C0.201408 7.49193 0.596527 7.17678 1.06399 7.13481L7.41378 6.56051L9.92466 0.70671C10.1098 0.277702 10.5314 0 10.9999 0C11.4684 0 11.89 0.277702 12.0752 0.707713L14.586 6.56051L20.9368 7.13481C21.4035 7.17778 21.7976 7.49193 21.9424 7.93565C22.0873 8.37937 21.9535 8.86606 21.6005 9.17285L16.8008 13.3656L18.2161 19.5755C18.3197 20.0321 18.1418 20.5041 17.7614 20.778C17.557 20.9251 17.3178 21 17.0766 21C16.8686 21 16.6624 20.9442 16.4772 20.8338L10.9999 17.5731L5.52462 20.8338C5.12396 21.0739 4.6189 21.052 4.23939 20.778C3.85887 20.5033 3.68112 20.0311 3.78468 19.5755L5.2 13.3656L0.400312 9.17369C0.0473213 8.86606 -0.0874615 8.38021 0.0573921 7.93565Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/rating_star.ac61d6c7c6e525dab7d72ee7e70886ed.svg";
export { ForwardRef as ReactComponent };